// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as ConsultorioCirurgiaPlasticaFozDoIguacuRouteImport } from './routes/consultorio-cirurgia-plastica-foz-do-iguacu'
import { Route as DrKelsonKawamuraRouteImport } from './routes/dr-kelson-kawamura'
import { Route as EspecialidadesRouteImport } from './routes/especialidades'
import { Route as PoliticaDePrivacidadeRouteImport } from './routes/politica-de-privacidade'
import { Route as PrimeiraConsultaCirurgiaPlasticaRouteImport } from './routes/primeira-consulta-cirurgia-plastica'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as EspecialidadesIndexRouteImport } from './routes/especialidades.index'
import { Route as EspecialidadesAbdominoplastiaFozDoIguacuRouteImport } from './routes/especialidades.abdominoplastia-foz-do-iguacu'
import { Route as EspecialidadesLipoesculturaFozDoIguacuRouteImport } from './routes/especialidades.lipoescultura-foz-do-iguacu'
import { Route as EspecialidadesMamoplastiaDeAumentoFozDoIguacuRouteImport } from './routes/especialidades.mamoplastia-de-aumento-foz-do-iguacu'
import { Route as EspecialidadesMamoplastiaRedutoraFozDoIguacuRouteImport } from './routes/especialidades.mamoplastia-redutora-foz-do-iguacu'
import { Route as EspecialidadesMastopexiaComImplantesFozDoIguacuRouteImport } from './routes/especialidades.mastopexia-com-implantes-foz-do-iguacu'
import { Route as EspecialidadesMommyMakeoverFozDoIguacuRouteImport } from './routes/especialidades.mommy-makeover-foz-do-iguacu'
import { Route as EspecialidadesRinoplastiaFozDoIguacuRouteImport } from './routes/especialidades.rinoplastia-foz-do-iguacu'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminCategoriasRouteImport } from './routes/_authenticated/admin.categorias'
import { Route as AuthenticatedAdminGaleriaRouteImport } from './routes/_authenticated/admin.galeria'
import { Route as AuthenticatedAdminLixeiraRouteImport } from './routes/_authenticated/admin.lixeira'
import { Route as AuthenticatedAdminArtigosIdRouteImport } from './routes/_authenticated/admin.artigos.$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SlugRoute = SlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const ConsultorioCirurgiaPlasticaFozDoIguacuRoute = ConsultorioCirurgiaPlasticaFozDoIguacuRouteImport.update({
            id: '/consultorio-cirurgia-plastica-foz-do-iguacu',path: '/consultorio-cirurgia-plastica-foz-do-iguacu',getParentRoute: () => rootRouteImport
          })
const DrKelsonKawamuraRoute = DrKelsonKawamuraRouteImport.update({
            id: '/dr-kelson-kawamura',path: '/dr-kelson-kawamura',getParentRoute: () => rootRouteImport
          })
const EspecialidadesRoute = EspecialidadesRouteImport.update({
            id: '/especialidades',path: '/especialidades',getParentRoute: () => rootRouteImport
          })
const PoliticaDePrivacidadeRoute = PoliticaDePrivacidadeRouteImport.update({
            id: '/politica-de-privacidade',path: '/politica-de-privacidade',getParentRoute: () => rootRouteImport
          })
const PrimeiraConsultaCirurgiaPlasticaRoute = PrimeiraConsultaCirurgiaPlasticaRouteImport.update({
            id: '/primeira-consulta-cirurgia-plastica',path: '/primeira-consulta-cirurgia-plastica',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const EspecialidadesIndexRoute = EspecialidadesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EspecialidadesRoute
          })
const EspecialidadesAbdominoplastiaFozDoIguacuRoute = EspecialidadesAbdominoplastiaFozDoIguacuRouteImport.update({
            id: '/abdominoplastia-foz-do-iguacu',path: '/abdominoplastia-foz-do-iguacu',getParentRoute: () => EspecialidadesRoute
          })
const EspecialidadesLipoesculturaFozDoIguacuRoute = EspecialidadesLipoesculturaFozDoIguacuRouteImport.update({
            id: '/lipoescultura-foz-do-iguacu',path: '/lipoescultura-foz-do-iguacu',getParentRoute: () => EspecialidadesRoute
          })
const EspecialidadesMamoplastiaDeAumentoFozDoIguacuRoute = EspecialidadesMamoplastiaDeAumentoFozDoIguacuRouteImport.update({
            id: '/mamoplastia-de-aumento-foz-do-iguacu',path: '/mamoplastia-de-aumento-foz-do-iguacu',getParentRoute: () => EspecialidadesRoute
          })
const EspecialidadesMamoplastiaRedutoraFozDoIguacuRoute = EspecialidadesMamoplastiaRedutoraFozDoIguacuRouteImport.update({
            id: '/mamoplastia-redutora-foz-do-iguacu',path: '/mamoplastia-redutora-foz-do-iguacu',getParentRoute: () => EspecialidadesRoute
          })
const EspecialidadesMastopexiaComImplantesFozDoIguacuRoute = EspecialidadesMastopexiaComImplantesFozDoIguacuRouteImport.update({
            id: '/mastopexia-com-implantes-foz-do-iguacu',path: '/mastopexia-com-implantes-foz-do-iguacu',getParentRoute: () => EspecialidadesRoute
          })
const EspecialidadesMommyMakeoverFozDoIguacuRoute = EspecialidadesMommyMakeoverFozDoIguacuRouteImport.update({
            id: '/mommy-makeover-foz-do-iguacu',path: '/mommy-makeover-foz-do-iguacu',getParentRoute: () => EspecialidadesRoute
          })
const EspecialidadesRinoplastiaFozDoIguacuRoute = EspecialidadesRinoplastiaFozDoIguacuRouteImport.update({
            id: '/rinoplastia-foz-do-iguacu',path: '/rinoplastia-foz-do-iguacu',getParentRoute: () => EspecialidadesRoute
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCategoriasRoute = AuthenticatedAdminCategoriasRouteImport.update({
            id: '/categorias',path: '/categorias',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminGaleriaRoute = AuthenticatedAdminGaleriaRouteImport.update({
            id: '/galeria',path: '/galeria',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminLixeiraRoute = AuthenticatedAdminLixeiraRouteImport.update({
            id: '/lixeira',path: '/lixeira',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminArtigosIdRoute = AuthenticatedAdminArtigosIdRouteImport.update({
            id: '/artigos/$id',path: '/artigos/$id',getParentRoute: () => AuthenticatedAdminRoute
          })





const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminCategoriasRoute: AuthenticatedAdminCategoriasRoute,AuthenticatedAdminGaleriaRoute: AuthenticatedAdminGaleriaRoute,AuthenticatedAdminLixeiraRoute: AuthenticatedAdminLixeiraRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,AuthenticatedAdminArtigosIdRoute: AuthenticatedAdminArtigosIdRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const EspecialidadesRouteChildren = {
  EspecialidadesAbdominoplastiaFozDoIguacuRoute: EspecialidadesAbdominoplastiaFozDoIguacuRoute,EspecialidadesLipoesculturaFozDoIguacuRoute: EspecialidadesLipoesculturaFozDoIguacuRoute,EspecialidadesMamoplastiaDeAumentoFozDoIguacuRoute: EspecialidadesMamoplastiaDeAumentoFozDoIguacuRoute,EspecialidadesMamoplastiaRedutoraFozDoIguacuRoute: EspecialidadesMamoplastiaRedutoraFozDoIguacuRoute,EspecialidadesMastopexiaComImplantesFozDoIguacuRoute: EspecialidadesMastopexiaComImplantesFozDoIguacuRoute,EspecialidadesMommyMakeoverFozDoIguacuRoute: EspecialidadesMommyMakeoverFozDoIguacuRoute,EspecialidadesRinoplastiaFozDoIguacuRoute: EspecialidadesRinoplastiaFozDoIguacuRoute,EspecialidadesIndexRoute: EspecialidadesIndexRoute
}

const EspecialidadesRouteWithChildren = EspecialidadesRoute._addFileChildren(EspecialidadesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,SlugRoute: SlugRoute,AuthRoute: AuthRoute,BlogRoute: BlogRoute,ConsultorioCirurgiaPlasticaFozDoIguacuRoute: ConsultorioCirurgiaPlasticaFozDoIguacuRoute,DrKelsonKawamuraRoute: DrKelsonKawamuraRoute,EspecialidadesRoute: EspecialidadesRouteWithChildren,PoliticaDePrivacidadeRoute: PoliticaDePrivacidadeRoute,PrimeiraConsultaCirurgiaPlasticaRoute: PrimeiraConsultaCirurgiaPlasticaRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)